

if (!customElements.get("keen-video")) {
    customElements.define(
    "keen-video",
    class KeenVideo extends HTMLElement {
        constructor() {
            super()
            this.isMobile = window.FoxTheme.config.mqlMobile
            this.togglePlayBtn = this.querySelector('.play-toggle-btn')
            this.toggleMuteBtn = this.querySelector('.mute-toggle-btn')
            this.playBtn = this.querySelector('.play-btn')
            this.pauseBtn = this.querySelector('.pause-btn')
            this.muteBtn = this.querySelector('.mute-btn')
            this.unmuteBtn = this.querySelector('.unmute-btn')
            this.videoDom = this.querySelector('video')
            this.init();
        }

        init() {
            if (!this.videoDom) return
            this.videoDom.play()
            if (this.playBtn && this.pauseBtn) {
                this.playBtn.addEventListener('click', () => {
                    this.play()
                    this.playBtn.classList.add('hidden')
                    this.pauseBtn.classList.remove('hidden')
                })

                this.pauseBtn.addEventListener('click', () => {
                    this.pause()
                    this.pauseBtn.classList.add('hidden')
                    this.playBtn.classList.remove('hidden')
                })
            }

            if (this.muteBtn && this.unmuteBtn) {
                this.muteBtn.addEventListener('click', () => {
                    this.mute()
                    this.muteBtn.classList.add('hidden')
                    this.unmuteBtn.classList.remove('hidden')
                })

                this.unmuteBtn.addEventListener('click', () => {
                    this.unmute()
                    this.unmuteBtn.classList.add('hidden')
                    this.muteBtn.classList.remove('hidden')
                })
            }
        }

        togglePlayBtns(bool) {
            if (!this.togglePlayBtn) return
            const toShow = bool ?? this.togglePlayBtn.classList.has('hidden')
            if (toShow) {
                this.togglePlayBtn.classList.remove('hidden')
            } else{
                this.togglePlayBtn.classList.add('hidden')
            }
        }

        toggleMuteBtns(bool) {
            if (!this.toggleMuteBtn) return
            const toShow = bool ?? this.toggleMuteBtn.classList.has('hidden')
            if (toShow) {
                this.toggleMuteBtn.classList.remove('hidden')
            } else{
                this.toggleMuteBtn.classList.add('hidden')
            }
        }


        play() {
            if (this.videoDom) {
                this.videoDom.play()
                this.videoDom.click()
                this.playVideo?.()
            }
        }

        pause() {
            if (this.videoDom) {
                this.videoDom.pause()
                this.pauseVideo?.()
            }
        }

        mute() {
            if (this.videoDom) {
                this.videoDom.muted = true
            }
        }

        unmute() {
            if (this.videoDom) {
                this.videoDom.muted = false
            }
        }
    })
}


if (!customElements.get("keen-slider")) {
    customElements.define(
    "keen-slider",
    class KeenSlider extends HTMLElement {
        constructor() {
            super()
            this.curIndex = 0
            this.gap = 16
            this.timer = null
            this.timeDuration = (this.dataset.duration ?? 6) * 1000
            this.pageX = null
            this.isMouseMoveOver = false
            this.init();
        }

        isMobile() {
            return window.FoxTheme.config.mqlMobile
        }

        isTablet() {
            return window.FoxTheme.config.mqlTablet
        }

        init() {
            this.initStyle()
            this.initEvent()
            this.setActiveItem(this.curIndex)
            this.startLoop()
        }

        initEvent() {
            this.getChildren().forEach((child) => {
                const keenVideo = child.querySelector('keen-video')
                if (!keenVideo) return
                keenVideo.playVideo = () => {
                    this.startLoop()
                }
                keenVideo.pauseVideo = () => {
                    this.stopLoop()
                }
            })

            window.addEventListener('resize', FoxTheme.utils.debounce(() => {
                const canLoop =  this.changePositionOfChildren(this.curIndex)
                // if (canLoop) {
                //     this.startLoop()
                // } else {
                //     this.stopLoop()
                // }
            }, 50))

            if (this.isMobile() || this.isTablet()) {
                this.addEventListener('touchstart', this.handleMouseDown.bind(this))
                this.addEventListener('touchend', this.handleMouseUp.bind(this))
            } else {
                this.addEventListener('mousedown', this.handleMouseDown.bind(this))
                this.addEventListener('mouseup', this.handleMouseUp.bind(this))
            }
        }

        clearStyleAboutLoop() {
            this.getChildren().forEach((child) => {
                child.style.transform = ''
            })
        }

        getChildren() {
            return Array.from(this.children)
        }

        setActiveItem(index){
            if (index == null || !this.children.length || index < 0 || index >= this.children.length) return
            if (this.curIndex !== index) {
                const oldChild = this.children[this.curIndex]
                oldChild.classList.remove('active')
                const keenVideo = oldChild.querySelector('keen-video')
                if(keenVideo) {
                    keenVideo.pause()
                    keenVideo.toggleMuteBtns(false)
                    keenVideo.togglePlayBtns(false)
                }
            }
            const newChild = this.children[index]
            const newKeenVideo = newChild.querySelector('keen-video')
            if (newKeenVideo) {
                newKeenVideo.toggleMuteBtns(true)
                newKeenVideo.togglePlayBtns(true)
                newKeenVideo.play()
            }
            newChild.classList.add('active')
            this.changePositionOfChildren(index)
            this.curIndex = index
            this.startLoop()
        }

        getWidthOfChildren() {
            return this.isMobile() ? 250 : 300
        }

        initStyle() {
            const width = this.getWidthOfChildren()
            Array.from(this.children).forEach((child) => {
                child.style.flex = `0 0 ${width}px`
                child.style.width = `${width}px`
                child.style.minWidth = `${width}px`
            })
            const clientWidth = window.document.documentElement.clientWidth
            const offsetLeft = this.children.length % 2 === 0 ? (clientWidth - width) - this.gap*2 : 0
            if (offsetLeft > 0) {
                this.style.left = `${offsetLeft}px`
            }
        }

        checkShouldLoopSlide() {
            const childrenWidth = this.getWidthOfChildren()
            const totalWidthOfChildren = (this.children.length - 1) * (childrenWidth + this.gap) + childrenWidth
            const clientWidth = window.document.documentElement.clientWidth
            return totalWidthOfChildren > clientWidth;
        }

        getEdgeSlideItemIndex(index) {
            const children = this.getChildren()
            const oldCurIndex = this.curIndex
            const startIndexForRevert = Math.ceil(children.length / 2) - 1
            let targetIndex = null
            if (oldCurIndex === index) return targetIndex
            const isFirstToLast = oldCurIndex === 0 && index === children.length - 1
            const isLastToFirst = index === 0 && oldCurIndex === children.length - 1
            if ((oldCurIndex > index && !isLastToFirst) || isFirstToLast) {
                targetIndex = (oldCurIndex + startIndexForRevert) % (children.length)
            } else if ((oldCurIndex < index && !isFirstToLast) || isLastToFirst) {
                targetIndex = (oldCurIndex < startIndexForRevert ?  (oldCurIndex + children.length) : oldCurIndex) - startIndexForRevert
            }
            return targetIndex
        }

        calculatePositionOfChildren(index) {
            const children = this.getChildren()
            const clientWidth = window.document.documentElement.clientWidth
            const childrenWidth = this.getWidthOfChildren()
            const totalWidthOfChildren = children.length * childrenWidth
            let newChildren = children
            let startIndexForRevert = Math.ceil(children.length / 2) - 1
            let startLeft = (startIndexForRevert - index) * childrenWidth
            const maxIndex = children.length - 1
            newChildren.forEach((child, i) => {
                let diffFromIndex = i - index
                if (Math.abs(diffFromIndex) > startIndexForRevert) {
                    if (diffFromIndex < 0) {
                        diffFromIndex = children.length + i - index
                        if (i === 0) {
                            startLeft = (diffFromIndex + startIndexForRevert) * childrenWidth
                        }
                    } else {
                        if (diffFromIndex - startIndexForRevert === 1) {
                            startLeft = -(i * childrenWidth + startIndexForRevert * this.gap)
                            diffFromIndex = 0
                        } else {
                           diffFromIndex = i - maxIndex + 1
                        }
                    }
                } else {
                    startLeft = (startIndexForRevert - index) * childrenWidth
                }
                const left = startLeft + diffFromIndex * this.gap
                child.style.transform = `translate3d(${left}px, 0, 0)`
            })
        }

        changePositionOfChildren(index) {
            if (index == null) return
            const children = this.getChildren()
            if (index < 0 || index >= children.length) return
            const checkShouldLoopSlide = this.checkShouldLoopSlide()
            if (!checkShouldLoopSlide) {
                this.classList.add('normal-list')
                this.clearStyleAboutLoop()
                return false
            } else {
                this.classList.remove('normal-list')
            }
            const edgeMovedIndex = this.getEdgeSlideItemIndex(index)
            if (edgeMovedIndex != null) {
                children[edgeMovedIndex].style.opacity = 0
            }
            requestAnimationFrame(() => {
                this.calculatePositionOfChildren(index)
                setTimeout(() => {
                    if (edgeMovedIndex != null) {
                        children[edgeMovedIndex].style.opacity = 1
                    }
                }, 500)
            })
            return true
        }

        startLoop() {
            if (this.timer) {
                clearTimeout(this.timer)
            }
            this.timer = setTimeout(() => {
                let newIndex = this.curIndex + 1
                if (newIndex === this.getChildren().length) {
                    newIndex = 0
                }
                this.setActiveItem(newIndex)
            }, this.timeDuration);
        }

        stopLoop() {
            if (this.timer) {
                clearTimeout(this.timer)
            }
        }

        handleMouseDown(e) {
            const pageX = e.changedTouches?.[0]?.pageX ?? e.pageX
            this.pageX = pageX
        }

        handleMouseUp(e) {
            if (this.pageX == null) return
            const pageX = e.changedTouches?.[0]?.pageX ?? e.pageX
            const diffPageX = pageX - this.pageX
            if (diffPageX !== 0) {
                let newIndex = this.curIndex
                const childrenCount = this.getChildren().length
                if (diffPageX > 0) {
                    newIndex -= 1
                    if (newIndex < 0) {
                        newIndex = childrenCount - 1
                    }
                } else {
                    newIndex += 1
                    if (newIndex >= childrenCount) {
                        newIndex = 0
                    }
                }
                this.setActiveItem(newIndex)
            }
            this.pageX = null
        }
    })
}

if (!customElements.get("product-keen-slider")) {
  customElements.define(
    "product-keen-slider",
    class ProductKeenSlider extends HTMLElement {
        constructor() {
            super()
            this.curIndex = 0;
            this.keenSlider = this.querySelector('keen-slider')
            this.init();
        }

        init() {
            this.batchHideVideoBtns()
            this.initEvent()
            requestAnimationFrame(() => {
                this.initStyle()
            })
        }

        initEvent() {
            const sliderItems = this.keenSlider?.getChildren?.()
            if (sliderItems?.length) {
                sliderItems.forEach((child, i) => {
                    const video = child.querySelector('video')
                    if (video) {
                        video.addEventListener('click', () => {
                            this.keenSlider.setActiveItem(i)
                        })
                    }
                })
            }
        }

        initStyle() {
            const sliderItems = this.keenSlider?.getChildren?.()
            if (sliderItems?.length) {
                sliderItems.forEach((child, i) => {
                    child.style.transition = `margin-top .25s linear,opacity .05s linear,transform .5s linear`
                })
            }
        }

        batchHideVideoBtns() {
            Array.from(this.querySelectorAll('keen-video')).forEach((video, i) => {
                if (i === this.curIndex) return
                video.toggleMuteBtns(false)
                video.togglePlayBtns(false)
                video.pause()
            })
        }

    })
}
